<template>
  <section class="billing-card">
    <div class="billing-head">
      <div>
        <div class="eyebrow">Suscripción</div>
        <h3>Quitar anuncios</h3>
      </div>
      <span v-if="isPremium" class="premium-chip">Activo</span>
    </div>

    <p class="copy">{{ copyText }}</p>

    <div v-if="mode === 'user'" class="meta-block">
      <div v-if="billing?.plan" class="meta-row"><strong>Plan:</strong> {{ planLabel }}</div>
      <div v-if="billing?.ads_disabled_until" class="meta-row"><strong>Vigencia:</strong> {{ formattedUntil }}</div>
      <div class="meta-row"><strong>Límites:</strong> {{ limitsCopy }}</div>
    </div>

    <div class="actions">
      <button v-if="mode === 'guest'" class="dark-btn" @click="$emit('open-auth')">Inicia sesión para verlo</button>
      <template v-else>
        <button v-if="!isPremium" class="dark-btn" @click="$emit('upgrade')">Ver planes</button>
        <button v-else class="soft-btn" @click="$emit('manage')">Administrar suscripción</button>
      </template>
    </div>
  </section>
</template>

<script>
export default {
  name: 'BillingPanel',
  props: {
    mode: { type: String, default: 'guest' },
    billing: { type: Object, default: () => ({}) },
  },
  emits: ['open-auth', 'upgrade', 'manage'],
  computed: {
    isPremium() {
      if (this.mode === 'user' && !this.billing?.loaded) return true;
      const plan = String(this.billing?.plan || '').toLowerCase();
      const status = String(this.billing?.status || '').toLowerCase();
      return !!(
        this.billing?.ad_free_active
        || ['monthly', 'yearly', 'lifetime'].includes(plan)
        || ['active', 'trialing', 'processing', 'complete', 'paid'].includes(status)
      );
    },
    formattedUntil() {
      if (!this.billing?.ads_disabled_until) return '';
      return new Date(this.billing.ads_disabled_until.replace(' ', 'T') + 'Z').toLocaleDateString('es-MX', {
        year: 'numeric', month: 'short', day: 'numeric',
      });
    },
    planLabel() {
      const map = { monthly: 'Mensual', yearly: 'Anual', lifetime: 'Vitalicio' };
      return map[this.billing?.plan] || this.billing?.plan || 'Free';
    },
    limitsCopy() {
      const limits = this.billing?.limits || {};
      const groups = limits.max_groups == null ? 'grupos ilimitados' : `${limits.max_groups} grupo`;
      const members = limits.max_members_per_group || 4;
      return `${groups}, ${members} usuarios por grupo`;
    },
    copyText() {
      if (this.mode === 'guest') {
        return 'Activa un plan para navegar sin publicidad y ampliar la colaboración de tus grupos.';
      }
      if (this.isPremium) {
        return 'Tu cuenta ya está ampliada. Tienes anuncios desactivados y acceso a colaboración extendida.';
      }
      return 'En free puedes tener 1 grupo con hasta 4 personas. Con un plan activas grupos ilimitados y hasta 100 usuarios por grupo.';
    },
  },
};
</script>

<style scoped>
.billing-card {
  border-radius: 22px;
  padding: 18px;
  border: 1px solid rgba(148, 163, 184, 0.18);
  background: linear-gradient(180deg, rgba(255,255,255,0.92), rgba(248,250,252,0.96));
  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.06);
}
.billing-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}
.eyebrow {
  font-size: 11px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #94a3b8;
}
h3 {
  margin: 4px 0 0;
  font-size: 22px;
  color: #0f172a;
}
.copy {
  margin: 12px 0 0;
  color: #475569;
  line-height: 1.5;
}
.meta-block {
  margin-top: 12px;
  display: grid;
  gap: 6px;
}
.meta-row {
  color: #334155;
  font-size: 14px;
}
.actions {
  margin-top: 16px;
}
.dark-btn,
.soft-btn {
  width: 100%;
  border: none;
  border-radius: 16px;
  padding: 12px 16px;
  font-weight: 800;
  cursor: pointer;
}
.dark-btn {
  background: #111827;
  color: white;
}
.soft-btn {
  background: rgba(59, 130, 246, 0.1);
  color: #1d4ed8;
}
.premium-chip {
  border-radius: 999px;
  background: rgba(34, 197, 94, 0.16);
  color: #166534;
  padding: 8px 10px;
  font-size: 12px;
  font-weight: 800;
}
</style>
